import { StyledKeylineDiv, StyledTable } from '../../../../ui/Styled';
import toTitleCase from '../../../../utils/toTitleCase';

const AdditionalDetails = ({ tariffCombination }) => (
  <>
    <div className="d-none d-sm-block">
      <StyledKeylineDiv>
        <StyledTable>
          <thead>
            <tr>
              <StyledTable.Th></StyledTable.Th>
              <StyledTable.Th className="text-left">Import tariff</StyledTable.Th>
              <StyledTable.Th className="text-left">Export tariff</StyledTable.Th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <StyledTable.Td className="py-4">
                <strong>Supplier</strong>
              </StyledTable.Td>
              <StyledTable.Td>
                {toTitleCase(tariffCombination?.tariff_combination?.import_tariff_supplier_name)}
              </StyledTable.Td>
              <StyledTable.Td>
                {toTitleCase(tariffCombination?.tariff_combination.export_tariff_supplier_name)}
              </StyledTable.Td>
            </tr>
            <tr>
              <StyledTable.Td className="py-4">
                <strong>Tariff</strong>
              </StyledTable.Td>
              <StyledTable.Td>{tariffCombination?.tariff_combination?.import_tariff_name}</StyledTable.Td>
              <StyledTable.Td>{tariffCombination?.tariff_combination.export_tariff_name}</StyledTable.Td>
            </tr>
            <tr>
              <StyledTable.Td className="py-4 text-nowrap">
                <strong>Tariff Type</strong>
              </StyledTable.Td>
              <StyledTable.Td>{tariffCombination?.tariff_combination?.import_tariff_type}</StyledTable.Td>
              <StyledTable.Td>{tariffCombination?.tariff_combination.export_tariff_type}</StyledTable.Td>
            </tr>
            {/* <tr>
          <StyledTable.Td className="py-4">
          <strong>Standing charges</strong>
          </StyledTable.Td>
          <StyledTable.Td>68.31p/day</StyledTable.Td>
          <StyledTable.Td>0p/day</StyledTable.Td>
          </tr> */}
            {/* <tr>
          <StyledTable.Td className="py-4">
          <strong>Comments</strong>
          </StyledTable.Td>
          <StyledTable.Td>
          {tariffCombination?.tariff_combination?.import_tariff_comments}
          </StyledTable.Td>
          <StyledTable.Td>
          {tariffCombination?.tariff_combination.export_tariff_comments}
          </StyledTable.Td>
          </tr> */}
          </tbody>
        </StyledTable>
      </StyledKeylineDiv>
    </div>
    <div className="d-block d-sm-none">
      <StyledKeylineDiv className="mb-4">
        <StyledTable>
          <thead>
            <tr>
              <StyledTable.Th></StyledTable.Th>
              <StyledTable.Th className="text-left">Import tariff</StyledTable.Th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <StyledTable.Td className="py-4">
                <strong>Supplier</strong>
              </StyledTable.Td>
              <StyledTable.Td>
                {toTitleCase(tariffCombination?.tariff_combination?.import_tariff_supplier_name)}
              </StyledTable.Td>
            </tr>
            <tr>
              <StyledTable.Td className="py-4">
                <strong>Tariff</strong>
              </StyledTable.Td>
              <StyledTable.Td>{tariffCombination?.tariff_combination?.import_tariff_name}</StyledTable.Td>
            </tr>
            <tr>
              <StyledTable.Td className="py-4 text-nowrap">
                <strong>Tariff Type</strong>
              </StyledTable.Td>
              <StyledTable.Td>{tariffCombination?.tariff_combination?.import_tariff_type}</StyledTable.Td>
            </tr>
            {/* <tr>
          <StyledTable.Td className="py-4">
            <strong>Standing charges</strong>
          </StyledTable.Td>
          <StyledTable.Td>68.31p/day</StyledTable.Td>
        </tr> */}
            {/* <tr>
          <StyledTable.Td className="py-4">
            <strong>Comments</strong>
          </StyledTable.Td>
          <StyledTable.Td>
            {tariffCombination?.tariff_combination?.import_tariff_comments}
          </StyledTable.Td>
        </tr> */}
          </tbody>
        </StyledTable>
      </StyledKeylineDiv>
      <StyledKeylineDiv>
        <StyledTable>
          <thead>
            <tr>
              <StyledTable.Th></StyledTable.Th>
              <StyledTable.Th className="text-left">Export tariff</StyledTable.Th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <StyledTable.Td className="py-4">
                <strong>Supplier</strong>
              </StyledTable.Td>
              <StyledTable.Td>
                {toTitleCase(tariffCombination?.tariff_combination.export_tariff_supplier_name)}
              </StyledTable.Td>
            </tr>
            <tr>
              <StyledTable.Td className="py-4">
                <strong>Tariff</strong>
              </StyledTable.Td>
              <StyledTable.Td>{tariffCombination?.tariff_combination.export_tariff_name}</StyledTable.Td>
            </tr>
            <tr>
              <StyledTable.Td className="py-4 text-nowrap">
                <strong>Tariff Type</strong>
              </StyledTable.Td>
              <StyledTable.Td>{tariffCombination?.tariff_combination.export_tariff_type}</StyledTable.Td>
            </tr>
            {/* <tr>
          <StyledTable.Td className="py-4">
            <strong>Standing charges</strong>
          </StyledTable.Td>
          <StyledTable.Td>0p/day</StyledTable.Td>
        </tr> */}
            {/* <tr>
          <StyledTable.Td className="py-4">
            <strong>Comments</strong>
          </StyledTable.Td>
          <StyledTable.Td>
            {tariffCombination?.tariff_combination.export_tariff_comments}
          </StyledTable.Td>
        </tr> */}
          </tbody>
        </StyledTable>
      </StyledKeylineDiv>
    </div>
  </>
);

export default AdditionalDetails;
